import { render, staticRenderFns } from "./shiChiGuanReceived.vue?vue&type=template&id=27d72609&scoped=true&"
import script from "./shiChiGuanReceived.vue?vue&type=script&lang=js&"
export * from "./shiChiGuanReceived.vue?vue&type=script&lang=js&"
import style0 from "./shiChiGuanReceived.vue?vue&type=style&index=0&id=27d72609&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d72609",
  null
  
)

export default component.exports